import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { BUSINESS, SERVICES, COVERAGE_AREAS } from '../data/content';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-forest text-white mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex flex-col gap-1.5 mb-5">
              <div className="flex items-baseline gap-0.5">
                <span className="font-outfit text-2xl font-light tracking-[0.08em] text-white leading-none">LARAÉ</span>
              </div>
              <span className="font-manrope text-[10px] uppercase tracking-[0.32em] text-oat">Logistics</span>
            </div>
            <p className="font-manrope text-sm text-white/70 leading-relaxed">
              Family-run, fully insured removals and transport across London, Greater London and nationwide. £1M Public Liability cover.
            </p>
          </div>

          <div>
            <h3 className="font-outfit text-base font-semibold mb-4">Services</h3>
            <ul className="space-y-2.5">
              {SERVICES.slice(0, 8).map(s => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="font-manrope text-sm text-white/70 hover:text-oat transition-colors">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-outfit text-base font-semibold mb-4">Coverage</h3>
            <ul className="space-y-2.5">
              {COVERAGE_AREAS.map(c => (
                <li key={c.slug}><Link to={`/coverage/${c.slug}`} className="font-manrope text-sm text-white/70 hover:text-oat transition-colors">{c.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-outfit text-base font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-3 font-manrope text-sm text-white/80">
              <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-oat" /><a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-oat">{BUSINESS.phone}</a></li>
              <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-oat" /><a href={`tel:${BUSINESS.mobileRaw}`} className="hover:text-oat">{BUSINESS.mobile} (mobile)</a></li>
              <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-oat" /><a href={`mailto:${BUSINESS.email}`} className="hover:text-oat break-all">{BUSINESS.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-oat" /><span>{BUSINESS.address}</span></li>
              <li className="flex items-start gap-3"><Clock size={16} className="mt-0.5 text-oat" /><span>{BUSINESS.hours}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-manrope text-xs text-white/60">© {year} Laraé Logistics. All rights reserved.</p>
          <div className="flex gap-5 font-manrope text-xs text-white/60">
            <Link to="/privacy" className="hover:text-oat">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-oat">Terms & Conditions</Link>
            <Link to="/admin/login" className="hover:text-oat">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
